import { render, staticRenderFns } from "./AstronautIcon.vue?vue&type=template&id=84eed4ea&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84eed4ea')) {
      api.createRecord('84eed4ea', component.options)
    } else {
      api.reload('84eed4ea', component.options)
    }
    module.hot.accept("./AstronautIcon.vue?vue&type=template&id=84eed4ea&", function () {
      api.rerender('84eed4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/AstronautIcon.vue"
export default component.exports